import { render } from "./ShuftiProResults.vue?vue&type=template&id=5ef62da7&scoped=true"
import script from "./ShuftiProResults.vue?vue&type=script&lang=js"
export * from "./ShuftiProResults.vue?vue&type=script&lang=js"

import "@/views/ClientSpace/custom-clientSpace.scss?vue&type=style&index=0&id=5ef62da7&lang=scss&scoped=true"
import "./custom-shufti-success.scss?vue&type=style&index=1&id=5ef62da7&lang=scss&scoped=true"
import "./ShuftiProResults.vue?vue&type=style&index=2&id=5ef62da7&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef62da7"]])

export default __exports__